<template>
  <div class="right">
    <threecategory  @initData="initData"></threecategory>
    <div class="live topprograss">
    	<div class="flex">
    		<div class="left flex1">
    			<div class="top">
    				<span style="margin-right: 15px;width: 70PX;">做题进度</span>
    				<div class="prograss">
    					<span class="rato"  :style="'width: '+data.alreadyQuestionCount/data.totalQuestionCount*100+'%'"></span>
    				</div>
    				<span class="done">已做：{{data.alreadyQuestionCount}}&nbsp; </span>/ 总数：{{data.totalQuestionCount}}
    			</div>
    			<div class="bottom" style="margin-top: 30px;">
    				<span style="margin-right: 15px;width: 70PX;">正确率</span>
    				<div class="prograss">
    					<span class="rato"  :style="'width: '+data.answerRatio"></span>
    				</div>
    				正确率：
    				<span class="done">{{data.answerRatio||'0%'}}</span>
    			</div>
    		</div>
    		<div class="btn" v-if="data.testQuestionCache" @click="handleGoOn()">
    			继续上次练习
    		</div>
    	</div>
    </div>
    <div style="height: 15px;background-color: #f8f8f8;"></div>
    <div class="live" style="border: 1px solid silver;background-color: #fff;">
    	<div class="title">
    		{{title}}
    	</div>
    	<template v-for="item,index in list">
    	  <div class="lists">
    	  	<div class="listtile" @click="handleToggle(index)">
    	  		{{item.title}}
    	  	</div>
    	  	<div class="list" v-for="voo in item.testQuestionsChildList" v-show="item.show">
    	  		<span class="childName">{{voo.title}}</span>
    	  		<div class="flex" style="align-items: center;width:473px;">
              <div class="prograss">
              	<span class="rato"  :style="'width: '+voo.myAlreadyCount/voo.totalQuestionsCount*100+'%'"></span>
              </div>
              <span class="done">{{voo.myAlreadyCount}}</span>/{{voo.totalQuestionsCount}}
              <span class="flex1"></span>
              <div class="viewWrap" style="margin-left: 0;"><span class="view" @click="handleToTest(voo.testQuestionsId,voo.totalQuestionsCount,1,voo.title,item.title)" v-if="voo.cacheCount>0">继续</span></div>
              <div class="viewWrap">

              	<span class="view" @click="handleToTest(voo.testQuestionsId,voo.totalQuestionsCount,0,voo.title,item.title)" v-if="isbuy">答题</span>
                <span class="view" @click="handleToTest(voo.testQuestionsId,voo.totalQuestionsCount,0,voo.title,item.title)" v-if="!isbuy && (voo.payStatus==0)">试做</span>
                <span class="view" @click="handleToBuy()" v-if="!isbuy && (voo.payStatus==1)">购买</span>
              </div>
            </div>
    	  	</div>
    	  </div>
    	</template>
    </div>

  </div>
</template>

<script>
  import bus from '../assets/utils/eventBus.js';
  import threecategory from './threecategory.vue'
  export default {
    components:{
      threecategory
    },
    name: 'Footer',
    props:{
      title:{
          type:String,
          default:()=>''
      },
      list:{
          type:Array,
          default:()=>[]
      },
      questionsStatus:{
        type:Number,
        default:()=>''
      }
    },
    data () {
      return {
          data:'',
          isbuy:this.$store.state.isbuy
      }
    },
    methods:{
      initData(){
        this.getData();
        this.$emit('initData')
      },
      handleToBuy(){
        this.$router.push('buy')
      },
      handleToggle(index){
          this.$forceUpdate()
          this.list[index].show=!this.list[index].show;

      },
      handleGoOn(){
        this.$router.push({path:'homework?questionsStatus='+this.questionsStatus+'&testQuestionsId='+this.data.testQuestionCache.testQuestionsId+'&cacheCount=1'})
      },
      handleToTest(testQuestionsId,totalQuestionsCount,cacheCount,title,firstTitle){
          window.sessionStorage.title=title
          window.sessionStorage.firstTitle=firstTitle
          console.log(this.questionsStatus);
          if(totalQuestionsCount==0){
            alert('上题中');
            return;
          }
          this.$router.push({path:'homework?questionsStatus='+this.questionsStatus+'&testQuestionsId='+testQuestionsId+'&cacheCount='+cacheCount})
      },
      getData(){
        this.$axios.get(this.$common.testPaper_selectQuestionsCountByAccountId+'?childQuestionStatus='+this.questionsStatus).then((res)=>{
              if(res.data.code==1){
                  this.data=res.data.data;

              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData();
    
      console.log(this.isbuy)

    },
    mounted() {
      bus.$on('isbuy',(obj)=>{

         this.isbuy=obj;
    //    this.showLogin=true;
      })
    }
  }
</script>

<style scoped="">
  .live {
    border: none;
  }
  .topprograss {
    border: 1px solid silver;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/examlist.vue